module.exports = __webpack_public_path__ + "img/08.afc6dd07.jpg";